import { trim } from 'lodash';

/**
 * Base filter to remove non valid values
 * @param data
 * @returns {boolean}
 */
export const baseTrim = (data: any) => trim(data);
